import { Outlet } from "react-router";

export const EmptyLayout = () => {
  return <Outlet />;
};
